import { Link, useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { setCountryCode } from '../../common/HelperMethods';
import { useContext } from 'react';
import { SiteContext } from '../../../context/SiteContext';

const DealerReferral = (): JSX.Element => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);

  const onBackClick = (): void => {
    const path: string = setCountryCode(
      PageAbsolutePath.Insurance.ConfirmationPage,
      site.countryCode
    );
    navigate(path);
  };

  return (
    <div className='dealerreferral'>
      <h3>Insurance Quote Declined</h3>
      <p>
        We're sorry but our underwriters are unable to provide a quote for this
        application We're pleased to provide this customer with
      </p>
      <br></br>
      <ol>
        <li>Free driveaway (expires midnight the day after the start day)</li>
        <li>Free One year Excess Return Voucher worth £250</li>
      </ol>
      <br></br>
      <p>
        Please go to{' '}
        <Link
          id='lnkDealerAdmin'
          className='in-text'
          to={PageAbsolutePath.Insurance.DealersAdminPage}>
          Dealer admin
        </Link>
      </p>
      <br></br>
      <hr />
      <h6 className='m1-bottom'>Monday – Thursday: 08.30 am – 7.30 pm</h6>
      <h6 className='m1-bottom'>Friday: 09.00 am – 6.00 pm</h6>
      <h6 className='m1-bottom'>Saturday: 09.00 am – 5.00 pm</h6>
      <h6 className='m1-bottom'>Sunday: Closed</h6>
      <ButtonBack
        name='btn-back'
        text='Back'
        onClick={onBackClick}
        additionalClassNames='btn-back m1-bottom'
      />
    </div>
  );
};
export default DealerReferral;
